export default __webpack_public_path__ + "static/media/undraw_researching_22gp.2f238e48.svg";